// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"desktopNavbar_searchInput__CvDvS"};